import { isNullOrUndefined } from 'helpers/utils/HTMLUtils';
import { Fragment } from 'react/jsx-runtime';

const languageValues = {
  'pt-br': {
    components: {
      select: {
        selectAll: 'Selecionar tudo',
        clearAll: 'Limpar tudo',
        panelFilterPlaceholder: 'Pesquisar',
        noOptionMessage: 'Nenhuma opção encontrada!',
        multiple: {
          numberOfItems: {
            items: (itens: number) =>
              `${itens} ite${itens !== 1 ? 'ns' : 'm'} selecionado${
                itens !== 1 ? 's' : ''
              }`,
          },
        },
        single: {
          fakeOption: 'Selecione...',
        },
      },
    },
    SubMenus: {
      acessoRapido: 'Acesso Rápido',
      assembleia: 'Assembleia',
      mensagens: 'Mensagens',
      presentes: 'Presentes',
      quorum: 'Quórum',
      videos: 'Vídeos',
      evento: 'Evento',
      dadosInformativos: 'Dados informativos',
      documentos: 'Documentos',
      confirmarPresenca: 'Confirmar Presença',
      votacaoPresencial: 'Votação Presencial',
      incluirMensagem: 'Incluir Mensagem',
      habilitarChat: 'Habilitar Chat',
      desabilitarChat: 'Desabilitar Chat',
      relatorio: 'Relatórios',
      adicionarConvidado: 'Adicionar Convidados',
      pautas: {
        title: 'Pautas',
        cadastrarPauta: 'Cadastrar pauta',
        liberarEmLote: 'Liberar pautas em lote',
        reordenarPautas: 'Reordenar pautas',
      },
      excluirEvento: {
        botao: 'Excluir evento',
        tituloModal: 'Confirma exclusão do evento',
        textoModal:
          'Para efetivar a exclusão do evento clique em confirmar.\nApós a exclusão do evento, as ações sobre essa assembleia não serão possíveis.',
        cancelar: 'Cancelar',
        confirmar: 'Confirmar',
      },
    },
    AlterarRepresentanteModal: {
      title: 'Coordenador de Núcleo',
      somenteUmaAlteracao:
        '* É permitida apenas uma alteração de representante por núcleo',
      subTitle: 'Representante efetivo',
      confirmarButton: 'Confirmar',
    },
    QuorumAssessorRoute: {
      title: 'Quórum',
      representados: 'Representados',
      agencia: 'Agência',
      nucleo: 'Núcleo',
      qtdConvocados: 'Qtd convocados',
      qtdContasRepresentadas: 'Qtd contas representadas',
      qtdContasAptas: 'Qtd contas\nrepresentadas aptas',
      presentes: '% Presentes',
      labelDisplayedRows: (from: number, to: number, count: number) =>
        `${from}-${to} de ${count}`,
      labelRowsPerPage: 'Linhas por página',
      qtdPresentes: 'Qtd presentes',
      coordenador: 'Coordenador',
      nomeConvocado: 'Nome do convocado',
      cpfCnpj: 'CPF/CNPJ',
      dataHora: 'Data e hora',
      alterarRepresentante: 'Alterar representante',
      representanteAlterado: 'Representante alterado',
      noData: 'Não foram encontrados dados',
    },
    FugaAlert: {
      assembleiaAssociadoLeaveTitle: 'Assembleia em andamento',
      assembleiaAssociadoLeaveMessage: {
        leaveMessage:
          'Há uma assembleia com votação em andamento. Deseja sair sem concluir a votação?',
        leaveMessageAGOAGEAOE:
          'Há uma assembleia com votação em andamento. Deseja sair sem concluir a votação do seu núcleo?',
        abstentionMessage:
          '\nSe "SIM", seu voto será computado como "Abstenção".',
      },
    },
    InputTime: {
      hoursLabel: 'Horas',
      minutesLabel: 'Minutos',
      secondsLabel: 'Segundos',
    },
    AbrirVotacaoPautaModal: {
      title: 'Duração da pauta',
      subTitle: 'Determine o tempo que a pauta ficará aberta para votação:',
      tempoLabel: 'Duração da pauta',
      confirmarButton: 'Confirmar',
      radioGroup: {
        tempo: 'Duração por tempo',
        periodo: 'Duração por período',
      },
      pickers: {
        datePlaceholder: 'Data fim da votação',
        dateLabel: 'Data fim da votação',
        dateCancelButton: 'Cancelar',
        timeLabel: 'Cancelar',
        timeCancelButton: 'Cancelar',
        minDateText: 'Data não pode ser anterior a data atual',
        maxDateText: 'Data não pode ser posterior a data de encerramento',
        minTimeText: 'Horário anterior ao início do evento',
        maxTimeText: 'Horário posterior ao fim do evento',
        timeAtual: 'Horário definido é anterior a hora atual',
      },
    },
    AssembleiaStatus: [
      'Não disponível',
      'Preparação',
      'Assembleia',
      'Pós assembleia',
      'Assembleia encerrada',
      'Assembleia encerrada sem quórum',
    ],
    UnauthorizedScreen: {
      label: 'Recarregue sua página para realizar o login.',
      callbackButton: 'Voltar para página inicial e realizar o login novamente',
    },
    UserRoleUnauthorizedScreen: {
      label: 'Recarregue sua página para realizar o login.',
      logoutButton: 'Voltar para tela inicial e realizar o login novamente',
    },
    AssembleiaDocsModal: {
      title: 'Documentos',
    },
    AssembleiaVideosModal: {
      title: 'Videos',
    },
    ChatModal: {
      aviso: {
        title: 'Aviso',
        description:
          'Esta mensagem está sendo respondida por outro colaborador.',
        jaFoiRespondida:
          'Esta mensagem já foi respondida por outro colaborador. Por favor, atualize o chat!',
        confirmar: 'Confirmar',
        atualizar: 'Atualizar',
      },
      excluir: {
        title: 'Excluir mensagem',
        description:
          'Essa mensagem está disponível para os associados.\nConfirma a exclusão?',
      },
      respostasPadrao: {
        title: 'Respostas padrão',
        selecao: 'Selecione uma das respostas padrão',
        semResposta:
          'Não há resposta padrão cadastrada para sua Cooperativa. Para cadastrar, acesse Menu > Parâmetros > Resposta padrão',
        obs: '* Opção disponível apenas para os perfis Admin e Gestão.',
        adicionar: 'Adicionar resposta padrão',
      },
    },
    TempoAcabouChatModal: {
      title: 'O tempo acabou',
      textWithMessage:
        'O tempo para responder a mensagem acabou. Por favor, atualize as mensagens e tente novamente.',
      textWithoutMessage: 'Sua mensagem era:',
      confirmar: 'Confirmar',
    },
    ResultadoParcialModal: {
      title: 'Resultado da votação',
      associados: {
        title: 'Acompanhamento por Agência e Núcleo:',
        agencia: (value: string) => `Agência: ${value}`,
        agenciaPlaceholder: 'Selecione uma agência',
        nucleo: (value: string) => `Núcleo: ${value}`,
        nucleoPlaceholder: 'Selecione um núcleo',
        quorumAtingido: (value: string) => `Quórum atingido: ${value}`,
        totalAssociadosAptos: (value: number) =>
          `Total de associados aptos: ${value}`,
        totalVotos: (value: number) => `Total de votos computados: ${value}`,
      },
      agenciaNucleo: 'Agência e Núcleo',
      agencia: 'Agência',
      evento: 'Evento',
      aoe: 'AOE',
      ago: 'AGO',
      age: 'AGE',
      error: 'error',
      sim: 'Sim',
      nao: 'Não',
      nucleoPercentage: ' núcleo',
      nucleosPercentage: ' núcleos',
      agenciaPercentage: ' agência',
      agenciasPercentage: ' agências',
      votoPercentage: ' voto',
      votosPercentage: ' votos',
      votaram: {
        true: {
          associados: {
            singular: 'Associado que votou',
            plural: 'Associados que votaram',
          },
          nucleos: {
            singular: 'Núcleo votou',
            plural: 'Núcleos votaram',
          },
        },
        false: {
          associados: {
            singular: 'Associado que não votou',
            plural: 'Associados que não votaram',
          },
          nucleos: {
            singular: 'Núcleo que não votou',
            plural: 'Núcleos que não votaram',
          },
        },
      },
      aptos: {
        associados: (count: any) => `Total de associados aptos: ${count}`,
        nucleos: (count: any) => `Total de núcleos presentes: ${count}`,
      },
      labelBaixarRelatorios: 'Baixar Resultados',
      labelAtualizar: 'Atualizar',
      totalParticipantes: {
        error: 'Não foi possível carregar o total de participantes',
        agenciaNucleo: (count: number | string) =>
          `Total de núcleos participantes nesta assembleia para a pauta: ${count}`,
        agencia: (count: number | string) =>
          `Total de agências participantes nesta assembleia para a pauta: ${count}`,
        evento: (count: number | string) =>
          `Total de presentes aptos: ${count}`,
      },
      totalQuorumAtingido: {
        error: 'Não foi possível carregar as informações do quórum',
        agenciaNucleo: (count: number | string) =>
          `Total de núcleos com quórum atingido nesta assembleia para a pauta: ${count}`,
        agencia: (count: number | string) =>
          `Total de agências com quórum atingido nesta assembleia para a pauta: ${count}`,
        evento: (count: number | string) => `Total de votos: ${count}`,
      },
    },
    AssembleiaPauta: {
      direcionamento: 'Opções de voto:',
      status: ['Bloqueada', 'Liberada', 'Encerrada'],
      itemAbstencao: 'Me abstenho',
      seTiverVotos:
        'Se desejar alterar seu voto, selecione uma opção diferente e clique no botão: Alterar voto.',
      bottomMessage: {
        alterarVoto: 'Alterar voto',
        votoEnviado: 'Voto enviado',
        visualizarPauta: 'Visualizar pauta',
        resultadoParcial: 'Ver resultados parciais',
        votarNestaPauta: 'Votar nesta pauta',
      },
      acoes: {
        abster: 'Me abstenho',
        confirmar: 'Votar',
        alterarVoto: 'Alterar voto',
        confirmado: 'Seu voto foi confirmado com sucesso.',
        computarVotoPresencial: 'Computar votos presenciais',
        liberarVotacao: 'Liberar para votação',
        reabrirVotacao: 'Reabrir para votação',
        encerrarVotacao: 'Encerrar votação',
        acompanharVotacao: 'Acompanhar a votação',
        visualizarResultados: 'Visualizar resultados',
        consolidarResultados: 'Consolidar resultados',
        liberarResultadoAssociados: 'Liberar para associados',
        liberarResultados: 'Liberar resultados',
        bloquearResultados: 'Bloquear resultados',
        resultadoParcial: 'Resultado parcial',
        resultadoFinal: 'Resultado final',
        verificarInconsistencia: 'Verificar inconsistências',
        computarVotos: 'Computar votos',
        reabrirVoto: 'Reabrir votação',
      },
      eleicaoTextButtom: 'Ver detalhes',
      textoVotoColaborador:
        'Conforme dispõe a legislação, o associado que possuía ou possuir relação empregatícia com a Cooperativa não está apto a votar e ser votado.',
      textoVotoRestrito:
        'Conforme dispõe a legislação, os membros dos órgãos de administração e fiscalização da cooperativa não poderão participar da votação dessa matéria.',
      textoVotoColaborador2:
        'Conforme dispõe a legislação, o associado que possuía ou possuir relação empregatícia com a Cooperativa não está apto a votar e ser votado.',
      textoVotoQuorum:
        'Nas Assembleias Gerais, a votação é liberada apenas para um dos coordenadores de núcleo presente (efetivo ou suplente). As opções de voto estão bloqueadas pois já há um coordenador participando da votação, representando seu núcleo',
      tabPauta: {
        agencia: (agencia: string) => `Agência ${agencia}`,
        nucleo: (nucleo: string) => `Núcleo ${nucleo}`,
        comissao: 'Comissão eleitoral',
      },
    },
    SeletorContasParaVotoModal: {
      title: 'Confirme sua presença',
      confirmLabel: 'Confirmar presença',
      textToggleSwitch: 'Irei representar?',
      headerTextConta: 'Conta',
      headerTextNuc: 'Núcleo',
      headerTextNomAsso: 'Nome do associado',
      headerTextContaNome: 'Conta\ne Nome do associado',
      headerTextPresen: 'Presença',
      responsiveLabelNome: 'Associado',
      textAceite:
        'Identificamos que você é representante legal da(s) conta(s) listada(s) abaixo.\nIndique a(s) que você irá representar e em seguida clique em confirmar presença.\n\nAtenção! O seu voto será replicado para todas as contas que está representando.',
      confirmAceite:
        'Eu aceito que meu voto seja multiplicado pelas contas que represento.',
      textPessoaColaborador:
        'Conforme dispõe a legislação, o associado que possuía ou possuir relação empregatícia com a cooperativa pode participar da assembleia, mas perde o direito de votar e ser votado, até que sejam aprovadas as contas do exercício em que ele deixou o emprego.',
      textContaColaborador: 'Conta Colaborador',
      textContaExColaborador: 'Conta ex-colaborador',
      colaboradorDesligado:
        'Conforme dispõe a legislação, o associado que possuía vínculo empregatício com a cooperativa pode participar da assembleia, mas perde o direito de votar e ser votado, até que sejam aprovadas as contas do exercício em que deixou o emprego',
    },
    BoxConfiguracaoVotos: {
      labelButton: 'Confirmar presença',
    },
    TopBar: {
      saudacao: (nome: string) => `Olá, ${nome}`,
    },
    UserMenu: {
      sair: 'Sair',
    },
    MainRoute: {
      title: 'Início',
    },
    MensagensAssessorRoute: {
      carregando: 'Carregando evento',
    },
    AssembleiaAssessorRoute: {
      bloqueiaEvento: 'Bloquear evento',
      presentes: 'Listagem de presentes',
      carregando: 'Carregando evento',
      situacao: (situacao: string) => `Situação: ${situacao}`,
      buttonAlterarSituacao: 'Alterar situação',
      buttonEditarTransmissao: 'Adicionar vídeo',
      buttonAtualizarParticipantes: 'Atualizar participantes',
      buttonRegistrarQuorum: 'Iniciar votação',
      buttonAssistirTransmissao: 'Transmissão',
      buttonEmFinalizacao: 'Em finalização',
      infoEmFinalizacao:
        'O evento está sendo finalizado.\nTente novamente mais tarde.',
      infoCardLabel: {
        quorumAtingido: 'Quórum atingido',
        participantes: 'Participantes online',
        contas: 'Associados',
        presencas: 'Pessoas presentes',
        aptos: 'Associados aptos',
      },
      quorumAtingido: {
        undefined: '-',
        true: 'Sim',
        false: 'Não',
      },
      CardModal: {
        quorumAtingidoBold1: 'Nas assembleias de núcleo e reuniões: ',
        quorumAtingido1:
          'Quando a indicação for “Sim” significa que pelo menos um dos núcleos convocados para o evento, atingiu o número mínimo de associados presentes, para considerar as decisões do núcleo válidas. E se a indicação for “Não”? Significa que nenhum dos núcleos atingiu o número mínimo de associados presentes ainda. ',
        quorumAtingidoBold2: ' Nas assembleias gerais: ',
        quorumAtingido2:
          'quando houver a indicação de “Sim” significa que há pelo menos 10 núcleos com representação no evento, e se a indicação for “Não” significa que há menos de 10 núcleos com presença registrada até o momento.',
        participantesOnline:
          'Trata-se da quantidade de participantes logados na plataforma, assistindo a assembleia, neste momento. Atenção, esse é um número que pode variar a todo momento, conforme a entrada e saída dos participantes, do evento. Estão nessa contagem, associados convocados e convidados.',
        associados:
          'O número registrado aqui se refere à quantidade de associados e de contas com presenças confirmadas no evento até o momento. Dica: a relação desses associados e respectivas contas, encontra-se na opção de acesso rápido > presentes.',
        associadosAptos:
          'Associados aptos representam a quantidade dos associados presentes no evento que possuem direito a voto na assembleia. Mas quem não tem direito a voto? Conforme a legislação (Lei 5764/71), Art. 31: “O associado que aceitar e estabelecer relação empregatícia com a cooperativa, perde o direito de votar e ser votado, até que sejam aprovadas as contas do exercício em que ele deixou o emprego”. Portanto, os colaboradores ativos e desligados não são contabilizados como associados aptos nesse evento.',
        pessoasPresentes:
          'Esse dado registra a quantidade de pessoas presentes na assembleia. Como assim? Uma pessoa individualmente, pode representar várias contas. Portanto, essa contagem indica quantas pessoas que participaram da assembleia, confirmando presença para a(s) conta(s) que representa(m).',
      },
      liberarEmLote: {
        table: {
          header1: 'Detalhes',
          header2: 'Agência',
          header3: 'Núcleo',
          header4: 'Pauta',
          header5: 'Situação',
          option1: 'Pauta Padrão',
          option2: 'Pauta Conselho',
          option3: 'Pauta Coordenador',
          upperHeaderLabel: 'Liberar pautas selecionadas',
        },
        dropDown: {
          liberarPauta: 'Liberar pauta',
        },
        selectLabel: 'Selecione o tipo de pauta que deseja liberar',
        subTitle: 'Liberação de pauta em lote',
        tipoPauta: 'Tipo de pauta',
        selectPlaceholder: 'Selecionar itens',
        pautaPadrao: 'Padrão',
        pautaConselho: 'Conselho',
        pautaCoordenador: 'Coordenador',
        buttonText: 'Liberar pautas',
      },
      tooltip: {
        editar: 'Editar',
        excluirEvento: 'Excluir',
      },
      confirmarExclusao: 'Confirmar exclusão do evento',
      efetivarExclusao:
        'Para efetivar a exclusão do evento clique em confirmar.',
      alertExclusao:
        'Após a exclusão do evento, as ações sobre essa assembleia não serão possíveis.',
    },
    AssembleiaAssociadoRoute: {
      title: 'Assembleia',
      subtitlePre: 'Preparação',
      subtitleLive: 'Transmissão ao vivo',
      subtitleEncerrado: 'Evento encerrado',
      subtitlePos: 'Evento encerrado',
      subtitleStatus: 'Situação: ',
      loadingEvent: 'Aguarde, seu evento está sendo carregado',
      subtitleStatusLoading: 'Carregando situação da assembleia...',
      files: 'Documentos',
      pesquisa: 'Pesquisa',
      coopArea: 'Área da cooperativa',
      participate: 'Participe da pesquisa de satisfação',
      faq: {
        public: 'Perguntas frequentes',
        private: 'Minhas perguntas',
        ask: 'Enviar uma pergunta',
        form: {
          title: {
            label: 'Título',
            helper: 'Descreva um título',
          },
          description: {
            label: 'Descrição',
            helper: 'Descreva aqui sua pergunta',
          },
          success: 'Sua pergunta foi registrada com sucesso.',
        },
        tooltipPergunta: 'Acessar pergunta',
        tooltipResposta: 'Acessar resposta',
        perguntaLabel: 'Pergunta: ',
        respostaLabel: 'Resposta: ',
      },
      pautas: {
        title: 'Pautas',
        paginacao: (current: any, total: any) => {
          return (
            <Fragment>
              Você está na página <strong>{current}</strong> de{' '}
              <strong>{total}</strong>
            </Fragment>
          );
        },
        loading: 'Verificando pautas disponíveis',
        notFound:
          'Não há pautas disponíveis no momento, em caso de dúvidas, consulte o edital de convocação desta assembleia disponível na opção: Documentos.',
        ended:
          'A assembleia de núcleo da cooperativa foi encerrada.<br />Os resultados da votação, por núcleo, estão disponíveis no Site da Cooperativa na aba de assembleias.',
        filter: 'Filtre as pautas de acordo com a situação:',
        legenda: {
          title: 'Legenda:',
          secreta: 'Pauta Secreta',
          restrita: 'Pauta Restrita',
        },
        todasAsPautas: 'Todas as pautas',
        pautasSemVotos: 'Pautas sem voto',
        pautasVotadas: 'Pautas votadas',
        pautasBloqueadas: 'Pautas bloqueadas',
        pautasEncerradas: 'Pautas encerradas',
        acompanhamento: {
          emAndamento: 'Votação em andamento',
          emAndamentoDescription:
            'Clique para participar e faça a diferença na sua Cooperativa!',
          votacaoConcluida: 'Sua votação foi concluída',
          votacaoConcluidaDescription:
            'Parabéns por fazer a diferença na sua Cooperativa!',
          aguardeDescription:
            'Aguarde a liberação da próxima pauta e participe.',
        },
        toast: {
          erroDownloadDemonstrativo:
            'Erro ao solicitar o documento demonstrativo. Por favor, contate a sua cooperativa.',
          erroDownloadVoucher:
            'Erro ao solicitar o documento voucher. Por favor, contate a sua cooperativa.',
        },
      },
      infoCard: {
        participantes: 'Participantes online',
        documentos: 'Documentos',
        presenca: 'Presença',
        videos: 'Vídeos',
        pautas: 'Pautas',
      },
    },
    Consulta: {
      saudacoesLabel: 'Seja bem-vindo(a) às Assembleias 2021.',
      texto:
        'Nesse evento, você tem papel protagonista ao participar dos processos de decisão que vão orientar o uso de recursos da sua cooperativa, em busca de um mundo mais próspero e com oportunidades para todos.\n\nÉ assim, de um jeito democrático e transparente, que chegamos às decisões que fazem a diferença para sua comunidade, e para sua vida.',
      textoConsultaPrimeiro:
        'Seja bem-vindo(a) à página da primeira Assembleia Digital da Sicredi Sul MT.',
      textoConsultaSegundo:
        'Aqui você ficará por dentro dos temas que serão compartilhados nesse encontro e no dia 25/07/2020, dia da nossa Assembleia, poderá colocar em prática o seu direito de acompanhar e decidir os rumos da cooperativa.',
      textoConsultaTerceiro:
        'Apesar do cenário que estamos vivendo, estamos ao seu lado para juntos, fazermos a diferença na nossa comunidade e na sua vida financeira, de um jeito democrático e transparente.',
      textoBold:
        'Digite seu CPF ou CNPJ e confira como participar da Assembleia da sua cooperativa.',
      textFieldLabels: {
        placeHolder: 'Digite seu CPF ou CNPJ',
      },
      labelVideo: 'Clique e assista ao vídeo.',
      bannerAssembleia: {
        text: 'Assembleias 2025 Sicredi',
        description: () => {
          return (
            <Fragment>
              Não é só decidir. <br /> É a nossa cooperação fazendo a diferença
            </Fragment>
          );
        },
      },
      saibaMais: {
        title: 'Saiba mais sobre as nossas assembleias',
        saibaMaisLabel: 'Saiba mais',
        cards: {
          distribuicao: {
            title: 'Distribuição de resultados',
            subtitle:
              'Você sabe o que é distribuição de resultados e como ela acontece na prática? Neste vídeo, você, associado(a) do Sicredi, vai conhecer como a divisão ocorre, e, assim, a sua participação e experiência nas Assembleias serão ainda mais efetivas.',
          },
          oqueacontece: {
            title: 'O que acontece em uma assembleia',
            subtitle:
              'As Assembleias são essenciais em nosso modelo cooperativista. Quer saber como esse evento acontece? Assista ao vídeo e confira.',
          },
          porqueSuaParticipacaoImporta: {
            title: 'Por que a sua participação é tão importante?',
            subtitle:
              'Seu voto, enquanto associado(a), é fundamental para guiar as ações e direções da sua cooperativa. Nas Assembleias, discutimos e compartilhamos informações cruciais para o futuro. Entenda melhor como você pode fazer a diferença.',
          },
        },
      },
      personas: {
        title: 'Conheça alguns cargos representativos na cooperativa',
        coordenador: {
          name: 'Coordenador(a) de Núcleo',
          description:
            '"É um(a) associado(a) que representa a comunidade, participando de diversas atividades na cooperativa e agindo como porta-voz dos(as) demais associados(as)."',
        },
        conselheiroAdm: {
          name: 'Conselheiro(a) de Administração ',
          description:
            '"Estabelece as estratégias da cooperativa e acompanha sua execução. Também representa a cooperativa em reuniões e eventos, além de desenvolver o relacionamento com os(as) associados(as)."',
        },
        presidenteConselho: {
          name: 'Presidente do Conselho',
          description:
            '"Lidera o desenvolvimento, a gestão e a execução dos planos de trabalho da diretoria executiva, além da implementação dos programas sociais da cooperativa."',
        },
        conselheiroFiscal: {
          name: 'Conselheiro(a) Fiscal',
          description:
            '"Fiscaliza os atos da administração, verificando o cumprimento dos deveres legais e estatutários. Por isso, o Conselho Fiscal é um órgão independente do Conselho de Administração."',
        },
      },
      pesquisaCpfCnpj: {
        title: 'Confira o calendário da sua assembleia',
        subtitle:
          'Digite seu CPF ou CNPJ para saber quando e como você pode participar da Assembleia da sua cooperativa.',
        placeholder: 'Digite seu CPF ou CNPJ',
        erroAoPesquisar: 'Erro ao pesquisar o CPF ou CNPJ!',
      },
      informativos: {
        buttonLabel: 'Acessar assembleias',
        oQueSaoAssembleias: {
          title: 'O que são Assembleias?',
          subtitle:
            'As Assembleias do Sicredi são encontros anuais realizados em todas as cooperativas do Brasil, sendo um grande diferencial do nosso modelo cooperativista. Durante esses eventos, nossos associados(as) são atualizados sobre os principais acontecimentos e podem participar das decisões da cooperativa através do voto. É assim, de forma democrática e transparente, que juntos tomamos decisões que contribuem para o desenvolvimento de cada região e melhoram a vida financeira dos nossos associados(as).',
        },
        oQueAconteceNessesEncontros: {
          title: 'O que acontece nesses encontros?',
          subtitle:
            'Além de se atualizar sobre os principais acontecimentos e resultados da sua cooperativa ao longo do ano, é a oportunidade de decidir como os resultados financeiros serão distribuídos ou investidos, entre outras questões importantes. ',
        },
        participeDasAssembleias: {
          title: 'Participe das Assembleias do Sicredi 2025',
          subtitle:
            'Participe das Assembleias 2025 e tenha a oportunidade de vivenciar a essência do cooperativismo na prática, além de ficar sabendo dos impactos positivos que juntos estamos gerando na sua região. Não é só decidir, é a nossa cooperação fazendo a diferença. Em caso de dúvidas, entre em contato com o(a) seu(sua) gerente.',
        },
      },
    },
    ConsultaModal: {
      title: {
        true: 'Calendário de assembleias',
        false: 'Não encontrou a sua assembleia?',
      },
      subtitle: 'Encontramos as seguintes assembleias para você participar:',
      buttonLabel: 'Acessar assembleias',
      acessarMesmoAssim: 'Continuar e criar cadastro',
      emptyMessage:
        'Fique tranquilo, em breve você poderá conferir aqui. Se preferir, contate sua cooperativa ou fale com o seu gerente.',
      dataInicio: 'Data de início',
      dataTermino: 'Data de término',
      agencia: 'Presencial - Agência',
      presencial: 'Presencial',
      enderecoDigital: 'Para participar clique aqui',
      enderecoAgencia: 'Para participar, vá até a sua agência de Atendimento',
      referencia: 'Referência',
    },
    LoginAssociado: {
      botao: 'Acessar assembleias',
      tituloPagina: 'Assembleias Sicredi',
      acesseSicredi: 'Acesse sicredi.com.br',
    },
    VerificarInconsistencia: {
      title: 'Verificar inconsistências',
      subtitle: 'Conferir núcleos',
      filterPlaceholder: 'Selecione a ação que deseja fazer...',
      filterLabel: 'Ação',
      tooltipPrefix: 'Representante',
      nucleosPresentes: 'Verificar núcleos presentes sem voto',
      nucleosAusentes: 'Verificar núcleos ausentes',
      Agencia: 'Agência',
      Nucleos: 'Núcleos',
      opcaoDeVoto: {
        placeholder: 'Selecione a opção de voto...',
        label: 'Opção de voto',
      },
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Confirmar voto',
        confirmarAusencia: 'Confirmar ausência',
      },
      modals: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        confirmarAusencia:
          'Deseja confirmar a ausência dos núcleos selecionados?',
        confirmarVoto: (opcao: string) =>
          `Deseja confirmar a opção ${
            isNullOrUndefined(opcao)
              ? `"${'Sem manifestação de voto'}"`
              : `"${opcao}"`
          } para o(s) núcleo(s) selecionados?`,
      },
      toasts: {
        semNucleos: 'Sem resultados',
        sucessoAoConfirmar: 'Sucesso ao confirmar os votos!',
        erroAoConfirmar: 'Erro ao confirmar os votos!',
        sucessoAusencia: 'Sucesso ao confirmar a ausência do(s) núcleo(s)!',
        erroAusencia: 'Erro ao confirmar a ausência do(s) núcleo(s)!',
      },
    },
    LiberarPautasEmLote: {
      title: 'Liberar pautas em lote',
    },
    AssessorMensagens: {
      'nenhuma-conversa': 'Selecione uma mensagem para visualizar',
      'mensagem-em-resposta':
        'Esta mensagem está sendo respondida por outro colaborador.',
      'erro-parametro': 'Erro ao consutar o parâmetro da cooperativa',
      'mensagem-nao-selecionada': 'Nenhuma mensagem selecionada',
      answer: 'Responder',
      write: 'Escreva uma mensagem',
      public: 'Público',
      private: 'Privado',
      filtrar: 'Filtrar por situação',
      filtro: {
        respondido: 'Respondido',
        pendente: 'Pendente',
        emResposta: 'Em Resposta',
      },
      atualizar: 'Atualizar',
      respondido: (count: number) => `${count} respondido`,
      'em-resposta': (count: number) => `${count} em resposta`,
      respondido_plural: (count: number) => `${count} respondidos`,
      pendente: (count: number) => `${count} pendente`,
      pendente_plural: (count: number) => `${count} pendentes`,
      'sem-filtro': 'Sem filtro',
      search: 'Busca por associado',
      'forumStatus-0': 'Não habilitado',
      'forumStatus-1': 'Habilitado para convocados',
      'forumStatus-2': 'Habilitado para todos',
      'forum-habilitar': 'Habilitar chat',
      'forum-desabilitar': 'Desabilitar chat',
      'success-answer': 'A resposta foi encaminhada com sucesso.',
      send: {
        title: 'Incluir mensagem',
        inputLabel: 'Escreva a mensagem',
        cancel: 'Cancelar',
        done: 'Cadastrar',
      },
    },
    TelaInicialAssociado: {
      title: 'Seja bem-vindo(a) às Assembleias',
      asterisco: '* Clique sobre o evento para participar',
      blocoMinhasAssembleias: {
        title: 'Minhas Assembleias',
        subtitle: 'Acesse as assembleias e participe!',
        link: 'Acesse aqui',
        message: ' as assembleias da sua Cooperativa e participe!',
        notFound:
          'Não encontrou a sua assembleia? Fique tranquilo, em breve você poderá conferir aqui. Se preferir, contate sua Cooperativa ou fale com o seu Gerente.',
      },
      assembleias: {
        convocado: 'Participe das assembleias da sua Cooperativa',
        convidado: 'Eventos da Cooperativa',
        convidadoDesc: 'Acompanhe outros eventos da sua Cooperativa',
        nenhuma: 'Não há assembleias disponíveis',
        helper: '*Clique sobre o evento para participar.',
        buttonToggleConvocado: {
          false: 'Ver mais',
          true: 'Ver menos',
        },
        reuniao: 'Minhas Reuniões',
        acessereuniao: 'Acesse as reuniões e participe!',
      },
    },
    RespostaPautaModal: {
      title: (agencias: any) => `Assembleia de núcleo - Agência: ${agencias}`,
      title_plural: (agencias: any) =>
        `Assembleia de núcleo - Agências: ${agencias}`,
      resultadoParcial:
        '* O resultado final e consolidado será disponibilizado na Assembleia Geral com os Coordenadores de Núcleo.',
      resultadoFinal:
        '* O resultado final e consolidado será disponibilizado na Assembleia Geral com os Coordenadores de Núcleo.',
      error: 'Erro ao buscar resultado da pauta.',
      labelMeusNucleos: 'Meu(s) Núcleo(s)',
      labelTodosNucleos: 'Todos os núcleos',
      agenciaItem: (agencia: string) => `Agência: ${agencia}`,
      nucleoItem: (nucleo: string) => `Núcleo: ${nucleo}`,
      totalPresentesItem: (total: number) =>
        `Total de presentes aptos: ${total}`,
      loading: 'Carregando informações...',
    },
    AlertModalRepresentante: {
      naoSelecionouNada: {
        title: 'Sua presença não foi confirmada!',
        text: 'Caso deseje participar da votação, clique no botão “confirmar presença” na sua tela.',
      },
      aindaPodeSelecionarMais: {
        title: 'Sua presença não foi confirmada para todas as contas listadas!',
        text: 'Caso deseje votar pelas demais contas, clique no “confirmar presença” na sua tela.',
      },
    },
    PautaEleicaoModal: {
      title: 'Composição: ',
      presidente: 'Presidente',
      vice: 'Vice-presidente(s)',
      conselheiro: 'Conselheiro(s)',
      conselheiroEfetivo: 'Conselheiro(s) Efetivo(s)',
      conselheiroSuplente: 'Conselheiro(s) Suplente(s)',
    },
    AnexoPautaItem: {
      url: 'URL do vídeo',
      descricao: 'Descrição',
      adicionarVideo: 'Adicionar vídeo',
      adicionarDocumento: 'Adicionar documento',
      descObrigatoria: 'Descrição é obrigatória',
      urlObrigatoria: 'URL é obrigatória',
      urlInvalida: 'URL inválida',
      informeLink: 'Informe um link válido de vídeo do YouTube ou Vimeo',
      visivelLabel: 'Visível para o associado',
      adicionar: 'Adicionar anexo',
    },
    CadastroPautaModal: {
      title: 'Cadastrar pauta',
      labelButtom: 'Confirmar',
      tituloPautaLabel: 'Título da pauta',
      opcaoVotoLabel: 'Opção de voto',
      descricaoPauta: 'Descrição da pauta',
      labelButtonAdicionar: 'Adicionar opção',
      itensContainerTitle: 'Opção de voto',
      cancelButton: 'Cancelar',
      saveButton: 'Salvar pauta',
      registerButton: 'Cadastrar pauta',
      succesCastroPauta: 'Pauta cadastrada com sucesso.',
      errorCadastroPauta: 'Erro ao tentar cadastrar pauta.',
      tooltipButtomDeletar: 'Deletar',
      tipoPauta: 'Tipo de pauta',
      agencia: 'Agência',
      nucleo: 'Núcleo',
      pautaRestrita: 'Pauta restrita',
      pautaSecreta: 'Pauta secreta',
      labelAdicioneAnexos: 'Adicione anexos',
      labelAdicioneDocumento: 'Adicionar documento',
      labelAdicioneVideo: 'Adicionar vídeo',
      visivelParaAssociado: 'Visível para o associado',
      successSavingAnexos: 'Anexos salvos com sucesso!',
      errorSavingAnexos: 'Erro ao salvar anexos!',
    },
    EditarPauta: {
      labelButton: 'Editar pauta',
      title: 'Editar pauta',
      succesEditarPauta: 'Pauta editada com sucesso.',
      errorEditarPauta: 'Erro ao tentar editar pauta.',
    },
    ConfirmDeletarPauta: {
      labelButton: 'Deletar pauta',
      title: 'Deletar pauta',
      confirmText: (pauta: string) =>
        `Você realmente deseja deletar a pauta: '${pauta}'?`,
      cancelButton: 'Cancelar',
      confirmButton: 'Deletar',
      succesDeletarPauta: 'Pauta deletada com sucesso.',
      errorDeletarPauta: 'Erro ao tentar deletar pauta.',
    },
    VisualizacoesAssessor: {
      title: 'Visualizações',
      quorumAtingido: 'Quórum Atingido',
      syncButtonLabel: 'Atualizar participantes',
      sim: 'Sim',
      nao: 'Não',
      participantesOnlineLabel: 'Participantes online',
      associadosPresentesLabel: 'Associados presentes',
      contasRepresentadasLabel: 'Contas representadas',
    },
    VotoPresencial: {
      title: 'Votação presencial em agência',
      subtitle: 'Digite seu CPF e consulte as pautas disponíveis para votação.',
      label: 'Digite seu CPF',
      error: {
        empty: 'Campo obrigatório',
        invalid: 'CPF inválido',
        noRepeat: 'CPF já realizou votação',
      },
      presencaNotFound: 'Não foram encontrados dados para este CPF.',
      modal: {
        iniciarVotacao:
          'Confirma a liberação das pautas para iniciar a computar os votos?',
      },
      accessDeniedError:
        'Funcionalidade não disponível para este tipo de evento.',
    },
    EfetivacaoVotacao: {
      title: 'Efetivação da votação presencial na agência',
      subhead: (representante: string) =>
        `Olá ${representante}, você está representando as contas a seguir listadas. Escolha a sua opção de voto e confirme.`,
      conta: 'CONTA',
      nome: 'NOME DO ASSOCIADO',
      presenca: 'PRESENÇA',
      finalizadaTitle: 'Parabéns, sua votação foi concluída!',
      finalizadaSubtitle: 'Todas as pautas foram confirmadas.',
      confirmarLabel: 'Confirmar',
    },
    RelatorioPresentes: {
      title: 'Presentes',
      tableHead: {
        nomeConvocado: 'Nome do convocado',
        documento: 'CPF/CNPJ',
        agencia: 'Agência',
        nucleo: 'Núcleo',
        conta: 'Conta',
        coordenador: 'Coordenador',
        colaborador: 'Colaborador\nou conselheiro',
        presencaConfirmada: 'Presença confirmada',
        tipoPresenca: 'Tipo de presença',
        dataHoraPresente: 'Data e hora presença',
        tempoPermanencia: 'Tempo de permanência',
      },
      labelDisplayedRows: (from: number, to: number, count: number) =>
        `${from}-${to} de ${count}`,
      labelRowsPerPage: 'Linhas por página',
      labelFiltroAgencias: 'Agência',
      labelFiltroNucleos: 'Núcleos',
      labelFiltroCPFOrNpme: 'Nome ou CPF',
      labelFiltroBuscar: 'Buscar',
      labelButtonBaixarRelatorio: 'Baixar relatório',
      tipoPresenca: {
        ONLINE: 'Online',
        AGENCIA: 'Agência',
        OFFLINE: 'Offline',
        PRESENCIAL: 'Presencial',
        BIOMETRIA: 'Biometria',
      },
      tipoAssinatura: {
        FACIAL: 'Facial',
        FISICA: 'Assinatura Física',
        BIOMETRIA: 'Biometria',
      },
    },
    AssembleiaDateTime: {
      day: (day: number, month: any, year: number) =>
        `${day} de ${month} de ${year}`,
      'weekday-0': (day: number, month: number, year: number) =>
        `Domingo, ${day} de ${month} de ${year}`,
      'weekday-1': (day: number, month: number, year: number) =>
        `Segunda-feira, ${day} de ${month} de ${year}`,
      'weekday-2': (day: number, month: number, year: number) =>
        `Terça-feira, ${day} de ${month} de ${year}`,
      'weekday-3': (day: number, month: number, year: number) =>
        `Quarta-feira, ${day} de ${month} de ${year}`,
      'weekday-4': (day: number, month: number, year: number) =>
        `Quinta-feira, ${day} de ${month} de ${year}`,
      'weekday-5': (day: string, month: string, year: string) =>
        `Sexta-feira, ${day} de ${month} de ${year}`,
      'weekday-6': (day: string, month: string, year: string) =>
        `Sábado, ${day} de ${month} de ${year}`,
      'month-0': 'Janeiro',
      'month-1': 'Fevereiro',
      'month-2': 'Março',
      'month-3': 'Abril',
      'month-4': 'Maio',
      'month-5': 'Junho',
      'month-6': 'Julho',
      'month-7': 'Agosto',
      'month-8': 'Setembro',
      'month-9': 'Outubro',
      'month-10': 'Novembro',
      'month-11': 'Dezembro',
    },
    InconsistenciaVotosAGOModal: {
      title: 'Inconsistência em votos.',
      subTitle:
        'Para as agências e núcleos a seguir os votos não foram computados:',
      loadingSubtitle: 'Carregando agências e núcleos',
      whenVoidMessage:
        'Não há votos inconsistentes. Você pode realizar a liberação ou bloqueio dos resultados.',
      table: {
        columns: {
          agencias: 'Agências',
          nucleos: 'Núcleos',
        },
      },
      fields: {
        agencia: {
          label: 'Agência',
        },
        nucleo: {
          label: 'Núcleo',
        },
        opcaoVoto: {
          label: 'Opção de voto',
        },
        representante: {
          label: 'Núcleo representado por:',
          empty: 'Núcleo sem representação',
        },
      },
      buttons: {
        cancelButtonLabel: 'Cancelar',
        confirmButtonLabel: 'Confirmar voto',
      },
    },
    InconsistenciaDeVotosPresenciaisModal: {
      title: 'Inconsistência em votos no evento presencial',
      subTitle:
        'Não é possível alterar a situação do evento. Os votos da(s) agência(s) e núcleo(s) abaixo, referentes ao evento presencial, não foram preenchidos. Acesse a(s) pauta(s) e na opção "Computar votos presenciais", informe a quantidade de votos manifestados e em seguida, efetue a alteração da situação do evento.',
      subTitlePresent:
        'Não é possível encerrar a votação. Os votos da(s) agência(s) e núcleo(s) abaixo, não foram preenchidos. Clique em “Computar votos”, informe a quantidade de votos manifestados e em seguida, encerre a votação.',
      nomePauta: (nome: string) => `Pauta: ${nome}`,
      headerTitles: {
        agencias: 'Agências',
        nucleos: 'Núcleos',
      },
      loadingDados: 'Buscando dados...',
    },
    Parâmetros: {
      menuEntry: 'Parâmetros',
      title: 'Parâmetros por cooperativa',
      subhead: 'Nesta área poderá ser configurado parâmetros por Cooperativa',
      inputIncluirLabel: 'Selecione uma cooperativa',
      buttonIncluirLabel: 'Incluir cooperativa',
      noOptionsText: 'Sem opções',
      clearText: 'Limpar',
      headerTabela: {
        coop: 'Cooperativa',
        nomeCoop: 'Nome da cooperativa',
        respostaPadrao: 'Resposta padrão',
        flagMeuCadastroVoto: 'Meu cadastro\nbloqueia votação',
        tipoResultado: 'Apresentação de\nresultados (AGN e Reunião)',
        flagMeuCadastroChat: 'Meu cadastro\nbloqueia CHAT',
        flagAlterarVoto: 'Bloquear\nalteração de voto',
        flagOcultarNome: 'Ocultar nome do\nAssociado no Chat',
        flagAlterarTexto: 'Texto por cooperativa',
        acaoExcluir: 'Excluir',
      },
      buttonConfigTextLabel: 'Configurar texto',
      toast: {
        sucessoAlteração: 'Parâmetro alterado com sucesso.',
        sucessoExclusão: 'Parâmetros excluídos com sucesso.',
      },
      modalConfigurarTexto: {
        titulo: 'Configurar texto associado',
        linkVideo: 'Endereço do vídeo do associado:',
        texto: 'Texto do associado:',
        confirmar: 'Confirmar configurações',
        linkValido: 'Inserir link válido do Youtube',
      },
      tipoResultado: {
        agenciaNucleo: 'Agência e Núcleo',
        agencia: 'Agência',
        evento: 'Evento',
      },
      modalResultadoPadrao: {
        titulo: 'Resposta padrão',
        adicionarResposta: 'Adicionar nova resposta padrão',
        respostaPublicaOuPrivada:
          'Definir se as respostas serão públicas ou privadas',
        semRespostas: 'Não há resposta padrão. ',
        inputAssunto: 'Assunto',
        placeholderAssunto: 'Assunto da resposta padrão',
        inputMensagem: 'Mensagem',
        placeholderMensagem: 'Mensagem da resposta padrão',
        botaoCancelar: 'Cancelar',
        botaoSalvar: 'Salvar',
      },
    },
    DuvidasFrequentes: {
      title: 'Chat',
      assessorLabel: 'Administrador',
      perguntaFormPlaceholder: 'Escreva aqui sua mensagem',
      sucessoEnvio: 'Sua pergunta foi registrada com sucesso.',
      pesquisa: 'Participe da pesquisa de satisfação clicando aqui',
    },
    NotFound: {
      title: 'Página do evento indisponível no momento',
      error: 'Ocorreu um erro no acesso ao evento.',
      menu: 'Escolha a opção desejada clicando no menu',
    },
    RespostaPautaAGO: {
      title: {
        AGO: 'Assembleia Geral Ordinária',
        AGE: 'Assembleia Geral Extraordinária',
        AOE: 'Assembleia Geral Ordinária e Extraordinária',
        AGN: 'Assembleia de Núcleo',
        REU: 'Reunião de Núcleo',
      },
      parcial:
        '* O resultado final e consolidado será disponibilizado na Assembleia Geral com os Coordenadores de Núcleo.',
      final: '* Este é o resultado final da votação.',
      nucleo: (count: number) => `${count} núcleo`,
      nucleo_plural: (count: number) => `${count} núcleos`,
    },
    EditarDocumentosModal: {
      title: 'Documentos',
      empty: 'Não há documentos inseridos.',
      buttonDownload: 'Baixar',
      buttonCancel: 'Cancelar',
      buttonSave: 'Alterar',
      labelAvailable: 'Visível para o associado',
      noDescription: {
        disabled: 'Documento sem descrição',
        editing: 'Adicionar descrição',
      },
      buttonAdd: 'Adicionar novo documento',
      labelInputDescricao: 'Descrição do documento',
      labelCheckboxAvailable: 'Visível para o associado',
      fileError: {
        extension: 'Arquivo com formato inválido.',
        size: 'Tamanho de arquivo inválido (Máximo 10 MB).',
        name: 'Tamanho do nome do arquivo é maior que 200 caracteres.',
      },
    },
    Manutencao: {
      title: 'Seja bem-vindo(a) às Assembleias',
      message: (date: string) =>
        `Estamos constantemente buscando melhorias na sua experiência, está previsto no dia de hoje (${date}) uma atualização da nossa plataforma, portanto nosso sistema estará <strong>indisponível para acesso</strong>.\n\nNossa previsão de retorno é em até 8h, ou a qualquer momento, com novidades para você.`,
    },
    ListaLogins: {
      title: 'Listagem de associados cadastrados por Cooperativa',
      filtroCoop: {
        label: 'Pesquise por cooperativa',
        noOptionsText: 'Nenhum item encontrado',
      },
      filtroStartDate: {
        label: 'Data cadastro início',
        cancelLabel: 'Cancelar',
        maxDateError: 'Data precisa ser menor que data final',
        minDateError: 'Data precisa estar dentro do limite de 30 dias',
      },
      filtroEndDate: {
        label: 'Data cadastro fim',
        cancelLabel: 'Cancelar',
      },
      filtroSearch: {
        label: 'Pesquise por nome ou CPF',
      },
      advice: 'Selecione uma cooperativa.',
      tableLoading: 'Carregando lista.',
      dateErrorMessage: 'Corrija as datas.',
      tableHead: {
        coop: 'Cooperativa',
        nome: 'Nome do usuário',
        cpf: 'CPF',
        contas: 'Contas do usuário',
        dataCadastro: 'Data e hora do cadastro',
        dataAcesso: 'Data e hora do último acesso',
      },
      modalContas: {
        title: 'Lista de contas do usuário',
        agencia: 'Agência',
        conta: 'Conta',
        relacionamento: 'Relacionamento',
        nome: 'Nome associado',
        cpf: 'CPF/CNPJ',
        nucleo: 'Núcleo',
        carteira: 'Carteira',
        tipoRelacionamento: {
          ASSOCIADO: 'Associado',
          REPRESENTANTE: 'Representante',
          NAO_ASSOCIADO: 'Não associado',
        },
      },
      relatorioMenuLabel: 'Relatório de logins em Excel',
      empty: 'Não há associados cadastrados nesta cooperativa',
    },
    ProximosEventos: {
      title: 'Listagem de eventos',
      subtitle: '*Clique sobre o evento para participar',
    },
    VinculoAssociado: {
      title: 'Edição vínculo do associado',
      searchFieldLabel: 'Digite o nome ou CPF/CNPJ do associado',
      searchButtonLabel: 'Buscar',
      tableHead: {
        cpfCnpf: 'CPF/CPNPJ',
        nome: 'Nome do Associado',
        coop: 'Cooperativa',
        agencia: 'Agência',
        conta: 'Conta',
        nucleo: 'Núcleo',
        colaborador: 'Colaborador',
      },
      flagColaborador: ['Não colaborador', 'Colaborador', 'Conselheiro'],
      atualizandoAssociado: 'Atualizando associado',
      procurandoAssociado: 'Buscando associado(s)',
      sucessoUpdate: 'Associado atualizado.',
    },
    ConfirmarPresencaModal: {
      title: 'Confirmação de presença',
      inputLabel: 'Pesquise por nome ou CPF',
      inputPlaceholder: 'Digite o nome ou CPF',
      cancel: 'Cancelar',
      confirm: 'Confirmar presença',
      errLoadAccount: 'Erro ao carregar a conta informada',
      selectAccounts: 'Selecione as contas que deseja confirmar presença: ',
      selectAllAccounts: 'Selecionar todas as contas',
      mostAccount:
        'Identificamos que você é representante legal da(s) conta(s) listada(s) abaixo. Indique a(s) que você irá representar e em seguida clique em confirmar presença. Atenção! O seu voto será replicado para todas as contas que está representando.',
      cpf: 'CPF: ',
      cnpj: 'CNPJ: ',
      account: 'Conta: ',
      coop: 'Cooperativa: ',
      branch: 'Agência: ',
      nuc: 'Núcleo: ',
      confirmedPresence: 'Presença confirmada:',
      confirmedPresence2: 'Presença confirmada',
      confirmPresenceBy: 'Confirmar presença por:',
      physicalSignature: 'Assinatura Física',
      faceSignature: 'Facial',
      captureImage: 'Capturar imagem',
      capturePhoto: 'Tirar foto',
      captureAgain: 'Tirar novamente',
      switchCam: 'Alterar câmera',
      savePicture: 'Salvar foto',
      selectLegalRepresentative: 'Selecione o representante legal',
      errConfirmPresence: 'Problema ao confirmar presença.',
      tooltipMessage: (signature: string, ldap: string) =>
        `${signature} por ${ldap}`,
      withoutLegalRepresentative:
        'Não é possível confirmar presença para este associado pois não localizamos o(a) representante legal. Verifique o cadastro!',
      geolocationNotAvailable:
        'Geolocalização não é suportada neste dispositivo',
      geolocationNotAllowed:
        'Geolocalização não habilitada! É necessário permitir o acesso da localização pelas configurações do seu navegador.',
    },
    ComputeVotes: {
      title: 'Voto presencial',
      description:
        'Serão relacionadas apenas as agências e núcleos que ainda não possuem votos registrados',
      filter: {
        agencia: 'Agência',
        nucleo: 'Núcleo',
      },
      buttons: {
        update: 'Atualizar',
        cancel: 'Cancelar',
        cancelAclamacao: 'Cancelar aclamação',
        aclamacao: 'Aclamação',
        save: 'Salvar',
      },
      totalAptos: 'Total de associados aptos:',
      completedVote: 'Votações concluídas',
      computeVote:
        'Declaro que não há votos computados para essa agência e núcleo',
      semManifestacao: 'Sem manifestação de voto',
      allVotes: 'Você já computou votos em todas as agências e núcleos',
      errLoadNuc: 'Erro ao carregar os núcleos',
      errLoadAgn: 'Erro ao carregar as agências',
      errLiberarPautaPresencial: 'Problema ao encerrar a votação.',
      errReabrirPautaPresencial: 'Problema ao reabrir a pauta.',
      votacaoPresencialTitle: 'Votação presencial',
      liberarResultadosTitle: 'Liberar Resultados',
      atencaoLiberarResultadosSubtitle:
        'ATENÇÃO! Após liberação dos resultados, não é possível reabrir a votação e nem editar os resultados da votação. Confirma a liberação dos resultados da votação presencial para consolidação com a votação digital?',
      errLoadPauta: 'Erro ao carregar as pautas',
      errLiberarResultadoPresencial: 'Erro ao liberar o resultado presencial!',
    },
    resultadoPresencialNaoliberadoToast:
      'O resultado presencial dessa pauta não foi liberado.  Após liberação do resultado da votação presencial, a consolidação dos resultados poderá ser realizada.',
    Assessor: {
      TelaInicial: {
        Titulo: 'Olá seja bem-vindo ao Portal do Assessor.',
        Subtitulo: 'Confira a listagem de eventos:',
        filter: {
          codEvento: 'Código do evento',
          codEventoPlaceholder: 'Digite o código do evento',
          tipoEvento: 'Tipo do evento',
          tipoEventoPlaceholder: 'Selecione um tipo de evento',
          tipoEventoError: 'Tipo do evento é obrigatório',
          modalidadeEvento: 'Modalidade do evento',
          modalidadeEventoPlaceholder: 'Selecione uma modalidade de evento',
          modalidadeEventoError: 'Modalidade do evento é obrigatória',
          coopEvento: 'Cooperativa',
          coopEventoPlaceholder: 'Selecione uma cooperativa',
          coopEventoError: 'Cooperativa é obrigatória',
          statusEvento: 'Situação do evento',
          statusEventoPlaceholder: 'Selecione a situação do evento',
          statusEventoError: 'Situação do evento é obrigatória',
          dataInicioEvento: 'Data do evento (De)',
          eventoTest: 'Evento teste',
          eventoTestPlaceholder: 'Selecione se é um evento teste',
          dataInicioEventoPlaceholder: 'dd/mm/yyyy',
          dataInicioEventoObrigatoriaError: 'Data inicial é obrigatória',
          dataInicioEventoInvalidaError: 'Data inicial inválida',
          dataInicioEventoMaiorFinalError:
            'Data inicial deve ser anterior à data fim',
          dataFimEvento: 'Data do evento (Até)',
          dataFimEventoPlaceholder: 'dd/mm/yyyy',
          dataFimEventoObrigatoriaError: 'Data final é obrigatória',
          dataFimEventoInvalidaError: 'Data final inválida',
          dataFimEventoMaiorFinalError:
            'Data final deve ser posterior à data início',
          redefinirFiltro: 'Redefinir filtros',
          filtrar: 'Filtrar',
          novaAssembleia: 'Criar nova assembleia',
          novaReunião: 'Criar nova reunião',
        },
        tableHead: {
          codEvento: 'Código do evento',
          codCoop: 'Código da Cooperativa',
          descricao: 'Título do evento',
          tipo: 'Tipo do evento',
          modo: 'Modalidade',
          situacao: 'Situação',
          startDate: 'Data início',
          endDate: 'Data fim',
          initialTime: 'Horário início',
          actions: 'Ações',
        },
        tableLoading: 'Carregando lista de eventos.',
        empty:
          'Não há eventos para listar. Tente alterar os filtros da pesquisa.',
        actionEvento: 'Assembleia',
        actionPresentes: 'Listagem de presentes',
        actionQuorum: 'Quórum',
        actionMensagens: 'Mensagens',
        actionDownloadRelatorio: 'Relatório do evento',
        actions: {
          viewEdit: 'Visualizar/Editar',
          edit: 'Editar',
          view: 'Visualizar',
          clone: 'Duplicar',
          messages: 'Mensagem',
          quorum: 'Quórum',
          presenceList: 'Lista de presentes',
          qrCode: 'QR Code - Evento',
          qrCodeSurvey: 'QR Code - Pesquisa',
          relatory: 'Relatórios',
          votes: 'Votos',
          votingReport: 'Relatório de Votação',
          attachment: 'Anexos',
          deleteEvent: 'Excluir',
        },
        modals: {
          cloneModal: {
            message: 'O evento será duplicado. Deseja realizar?',
            warning:
              'O evento foi duplicado! Entretanto, não foi possível duplicar as pautas ou anexos.',
            error: 'Erro ao duplicar o evento selecionado!',
          },
          qrCodeModal: {
            title: 'QR Code do evento',
            titleSurvey: 'QR Code da pesquisa',
            warning:
              'O processo de convocação dos associados desta assembleia está em andamento. Por isso, não é possível acessá-la neste momento',
            text: 'Código do evento',
            text_survey: 'Pesquisa de satisfação',
            confirm: 'Baixar',
            cancel: 'Fechar',
          },
          deleteModal: {
            message: 'O evento será removido. Confirma a exclusão?',
            error: 'Erro ao excluir o evento selecionado!',
            buttons: {
              confirm: 'Deletar',
              cancel: 'Cancelar',
            },
          },
        },
      },
      Modal: {
        AdicionarConvidado: {
          title: 'Adicionar Convidados',
          titleEdit: 'Editar Convidado',
          input: {
            label: 'Nome do convidado',
            placeholder: 'Digite o nome do convidado',
          },
          cancelar: 'Cancelar',
          adicionar: 'Adicionar',
          editar: 'Editar',
          adicionarSair: 'Adicionar e sair',
        },
        CloneEvent: {
          Title: 'Duplicar',
          Semipresential: 'Campos para assembleias semipresenciais',
          Inputs: {
            Initial: {
              Date: {
                Label: 'Data de início',
                Placeholder: 'Data de início do evento*',
                PlaceholderPresential: 'Data de início evento híbrido*',
              },
              Hour: {
                Label: 'Horário de início',
                Placeholder: 'Horário de início do evento*',
                PlaceholderPresential: 'Horário de início evento híbrido*',
              },
            },
            End: {
              Date: {
                Label: 'Data de término',
                Placeholder: 'Data de término do evento*',
                PlaceholderPresential: 'Data de término evento híbrido*',
              },
              Hour: {
                Label: 'Horário de término',
                Placeholder: 'Horário de término do evento*',
                PlaceholderPresential: 'Horário de término evento híbrido*',
              },
            },
            QuantityAssociates: {
              Label: 'Número de associados esperados',
              Placeholder: 'Informe a quantidade esperada de associados*',
            },
          },
          Buttons: {
            Cancel: 'Cancelar',
            Save: 'Confirmar',
          },
        },
        Reservation: {
          Title: 'Nova Reserva',
          Success: {
            title: 'Reserva efetuada com sucesso',
            body: () => (
              <Fragment>
                Caso não houver o cadastramento do evento até o dia e horário
                selecionados, a reserva será <b>cancelada automaticamente.</b>
              </Fragment>
            ),
          },
          Error: {
            title: 'Infelizmente o evento não pode ser cadastrado.',
            body: () => (
              <Fragment>
                A estimativa de participantes para essa data e horário,{' '}
                <b>já atingiu a capacidade máxima da Plataforma.</b> Verifique a
                disponibilidade de outra data e horário.
              </Fragment>
            ),
            body2: () => (
              <Fragment>
                Em caso de dúvidas entre em contato conosco pelo Suporte da
                Fundação através do{' '}
                <a
                  href='https://chat.sicredi.com.br'
                  target={'_blank'}
                  rel='noreferrer'
                >
                  chat.sicredi.com.br
                </a>{' '}
                ou <b>Voip 8000 opção 7</b>
              </Fragment>
            ),
          },
          buttons: {
            voltarEdicao: 'Voltar à edição',
            reservarSair: 'Reservar e sair',
            continuarCadastramento: 'Continuar cadastramento',
          },
        },
        CopyStaves: {
          Title: 'Copiar pauta',
          Description: () => {
            return (
              <Fragment>
                Esta opção permite que você copie pautas de outros eventos.
                <br />
                Para selecioná-las, pesquise o evento abaixo:
              </Fragment>
            );
          },
          SelectAll: 'Selecionar todas',
          Search: {
            Label: 'Selecione o evento',
            Placeholder: 'Insira o título do evento para iniciar a pesquisa.',
          },
          buttons: {
            search: 'Consultar',
            cancel: 'Cancelar',
            copyOne: 'Copiar pauta',
            copyOther: 'Copiar pautas',
          },
        },
        InfoAssembly: {
          title: 'Dados informativos da Assembleia',
          eventoPresencialTitle: 'Horário do evento presencial',
          eventoDigitalTitle: 'Horário do evento digital',
          eventoAgenciaTitle: 'Horário do evento na agência',
          eventoSimultaneoTitle: 'Horário do evento presencial',
          tituloAssembleia: 'Título da assembleia',
          tituloPlaceholder: 'Digite o título do evento',
          descricaoAssembleia: 'Descrição da assembleia',
          descricaoPlaceholder: 'Digite a descrição do evento',
          dataEventoAssembleia: 'Data do evento',
          dataEventoAssembleiaPlaceholder: 'dd/mm/aaaa',
          dataEncerramentoEventoAssembleia: 'Data encerramento do evento',
          dataEncerramentoEventoAssembleiaPlaceholder: 'dd/mm/aaaa',
          horaEventoAssembleia: 'Horário do evento',
          horaEventoAssembleiaPlaceholder: 'Digite a hora de início...',
          horaEncerramentoEventoAssembleia: 'Horário encerramento do evento',
          horaEncerramentoEventoAssembleiaPlaceholder:
            'Digite a hora de encerramento...',
          buttons: {
            cancelButtonLabel: 'Cancelar',
            confirmButtonLabel: 'Confirmar',
          },
          fields: {
            nome: {
              label: 'Título da assembleia',
              placeholder: 'Digite o título para a assembleia',
              validation: {
                required:
                  'O campo "Título da assembleia" é de preencimento obrigatório.',
              },
            },
            descricao: {
              label: 'Descrição da assembleia',
              placeholder: 'Digite o descrição para a assembleia',
            },
            urlTransmissao: {
              label: 'URL de transmissão da assembleia',
              placeholder: 'Digite a URL de transmissão da assembleia',
              validation: {
                invalid:
                  'Apenas são permitidos links de vídeo do YouTube e Vimeo.',
                required:
                  'O campo "URL de transmissão da assembleia" é de preenchimento obrigatório.',
              },
            },
            dataInicioEventoPresencial: {
              label: 'Data início do evento:',
              validation: {
                invalid: 'A data informada não é válida.',
                required:
                  'O campo "Data início do evento" é de preencimento obrigatório.',
              },
            },
            horarioInicioEventoPresencial: {
              label: 'Horário de início do evento:',
              validation: {
                invalid: 'O horário informado não é válido.',
                required:
                  'O campo "Horário de início do evento" é de preencimento obrigatório.',
              },
            },
            dataFimEventoPresencial: {
              label: 'Data encerramento do evento:',
              validation: {
                invalid: 'A data informada não é válida.',
                invalidInterval:
                  'A data de encerramento informada é anterior a data de início.',
                required:
                  'O campo "Data encerramento do evento" é de preencimento obrigatório.',
              },
            },
            horarioFimEventoPresencial: {
              label: 'Horário de encerramento do evento:',
              validation: {
                invalid: 'O horário informado não é válido.',
                invalidInterval:
                  'O horário de encerramento informado é anterior ao horário de início.',
                required:
                  'O campo "Horário de encerramento do evento" é de preencimento obrigatório.',
              },
            },
            dataInicioEventoDigital: {
              label: 'Data início do evento:',
              validation: {
                invalid: 'A data informada não é válida.',
                required:
                  'O campo "Data início do evento" é de preencimento obrigatório.',
              },
            },
            horarioInicioEventoDigital: {
              label: 'Horário de início do evento:',
              validation: {
                invalid: 'O horário informado não é válido.',
                required:
                  'O campo "Horário de início do evento" é de preencimento obrigatório.',
              },
            },
            dataFimEventoDigital: {
              label: 'Data encerramento do evento:',
              validation: {
                invalid: 'A data informada não é válida.',
                invalidInterval:
                  'A data de encerramento informada é anterior a data de início.',
                required:
                  'O campo "Data encerramento do evento" é de preencimento obrigatório.',
              },
            },
            horarioFimEventoDigital: {
              label: 'Horário de encerramento do evento:',
              validation: {
                invalid: 'O horário informado não é válido.',
                invalidInterval:
                  'O horário de encerramento informado é anterior ao horário de início.',
                required:
                  'O campo "Horário de encerramento do evento" é de preencimento obrigatório.',
              },
            },
            dataEventoDigital: {
              label: 'Data do evento:',
              validation: {
                invalid: 'A data informada não é válida.',
                required:
                  'O campo "Data do evento" é de preencimento obrigatório.',
              },
            },
            horarioEventoDigital: {
              label: 'Horário do evento:',
              validation: {
                invalid: 'O horário informado não é válido.',
                required:
                  'O campo "Horário do evento" é de preencimento obrigatório.',
              },
            },
            dataInicioEventoAgencia: {
              label: 'Data início do evento:',
              validation: {
                invalid: 'A data informada não é válida.',
                required:
                  'O campo "Data início do evento" é de preencimento obrigatório.',
              },
            },
            horarioInicioEventoAgencia: {
              label: 'Horário de início do evento:',
              validation: {
                invalid: 'O horário informado não é válido.',
                required:
                  'O campo "Horário de início do evento" é de preencimento obrigatório.',
              },
            },
            dataFimEventoAgencia: {
              label: 'Data encerramento do evento:',
              validation: {
                invalid: 'A data informada não é válida.',
                invalidInterval:
                  'A data de encerramento informada é anterior a data de início.',
                required:
                  'O campo "Data encerramento do evento" é de preencimento obrigatório.',
              },
            },
            horarioFimEventoAgencia: {
              label: 'Horário de encerramento do evento:',
              validation: {
                invalid: 'O horário informado não é válido.',
                invalidInterval:
                  'O horário de encerramento informado é anterior ao horário de início.',
                required:
                  'O campo "Horário de encerramento do evento" é de preencimento obrigatório.',
              },
            },
          },
        },
        ChangeEventSituation: {
          title: 'Alterar situação da assembleia',
          confirmButton: 'Confirmar',
          cancelButton: 'Cancelar',
        },
        WarningBlockEvent: {
          title: 'Bloquear evento',
          description:
            'Verifique se todos os dispositivos do presencial foram finalizados.',
        },
        AgnVotesEditor: {
          warning:
            'Aviso: Essa opção permite que você edite a quantidade de votos por núcleo',
          branch: 'Agência',
          nucleous: 'Núcleo',
          description: 'Descrição',
          voteOption: 'Opção de voto',
        },
      },
      Evento: {
        Cadastro: {
          Titulo: (reu?: boolean) =>
            `Cadastro de nova ${reu ? 'Reunião' : 'Assembleia'}`,
          Etapas: {
            Dados: {
              Nome: 'Dados',
              DadosEvento: (reu?: boolean) =>
                `Dados ${reu ? 'da Reunião' : 'do Evento'}`,
              TituloHibrido: (value: any) =>
                `Campos para ${value} semipresenciais`,
              TituloHibridoPresencialDigital: 'Campos para o momento digital',
              TituloHibridoSimultaneo: 'Campos para o momento presencial',
              TituloHibridoDigitalAgencia: 'Campos para o momento agência',
              DescricaoHibrido: (value: any) =>
                `Nos campos abaixo, insira as informações de datas e horários do segundo momento da ${value} semipresencial.`,
              DescricaoHibridoPresencialDigital:
                'Nos campos abaixo, insira as informações de datas e horários do momento digital.',
              DescricaoHibridoSimultaneo:
                'Nos campos abaixo, insira as informações de datas e horários do momento presencial.',
              DescricaoHibridoDigitalAgencia:
                'Nos campos abaixo, insira as informações de datas e horários do momento agência.',
              EventoTeste:
                'Assembleias testes não são oficiais, elas servem apenas para praticar a criação do evento.',
              EventoTesteREU:
                'Reuniões de teste não são oficiais, elas servem apenas para praticar a criação do evento.',
              Campos: {
                Titulo: {
                  Label: (reu?: boolean) =>
                    `Título da ${reu ? 'reunião' : 'assembleia'}`,
                  Placeholder: (reu?: boolean) =>
                    `Título do evento da ${reu ? 'reunião' : 'assembleia'}*`,
                },
                EventoTeste: {
                  Label: 'Assembleia teste',
                  LabelREU: 'Reunião teste',
                },
                Cooperativa: {
                  Label: 'Cooperativa',
                  Placeholder: 'Nenhuma selecionada*',
                },
                Tipo: {
                  Label: (reu?: boolean) =>
                    `Tipo ${reu ? '' : 'da assembleia'}`,
                  Placeholder: (reu?: boolean) =>
                    `Selecione o tipo de ${reu ? 'reunião' : 'assembleia'}*`,
                },
                Modalidade: {
                  Label: (reu?: boolean) =>
                    `Modalidade da ${reu ? 'reunião' : 'assembleia'}`,
                  Placeholder: (reu?: boolean) =>
                    `Selecione a modalidade da ${
                      reu ? 'reunião' : 'assembleia'
                    }*`,
                },
                Convocados: {
                  Titulo: 'Estarão convocados',
                  Coordenadores: 'Coordenadores',
                  Associados: 'Associados',
                },
                MicrosoftTeams: {
                  Label: 'Usarei o Teams',
                },
                Descricao: {
                  Label: 'Descrição',
                  Placeholder: (reu?: boolean) =>
                    `Descrição do evento da ${reu ? 'reunião' : 'assembleia'}`,
                },
                QuantidadeAssociados: {
                  Label: 'Número de associados esperados',
                  Placeholder: 'Informe a quantidade esperada de associados*',
                },
                Link: {
                  Label: 'Link de transmissão',
                  Placeholder: (value: string) =>
                    `Link de transmissão da ${value}*`,
                },
                Data: {
                  Inicio: {
                    Label: 'Data de início',
                    Placeholder: (reu?: boolean) =>
                      `Data de início da ${reu ? 'reunião' : 'assembleia'}*`,
                    PlaceholderPresencial: 'Data de início evento presencial*',
                    Hora: {
                      Label: 'Horário de início',
                      Placeholder: (value: string) =>
                        `Horário de início da ${value}*`,
                      PlaceholderPresencial:
                        'Horário de início evento presencial*',
                    },
                  },
                  Fim: {
                    Label: 'Data de término',
                    Placeholder: (reu?: boolean) =>
                      `Data de término da ${reu ? 'reunião' : 'assembleia'}*`,
                    PlaceholderPresencial: 'Data de término evento presencial*',
                    Hora: {
                      Label: 'Horário de término',
                      Placeholder: (reu?: boolean) =>
                        `Horário de término da ${
                          reu ? 'reunião' : 'assembleia'
                        }*`,
                      PlaceholderPresencial:
                        'Horário de término evento presencial*',
                    },
                  },
                },
                DataHibrido: {
                  Inicio: {
                    Label: 'Data de início',
                    LabelOnline: 'Data de início evento online',
                    Placeholder: 'Data de início*',
                    PlaceholderOnline: 'Data de início evento online*',
                    Hora: {
                      Label: 'Horário de início',
                      LabelOnline: 'Horário de início evento online',
                      Placeholder: 'Horário de início*',
                      PlaceholderOnline: 'Horário de início evento online*',
                    },
                  },
                  Fim: {
                    Label: 'Data de término',
                    LabelOnline: 'Data de término evento online',
                    Placeholder: 'Data de término*',
                    PlaceholderOnline: 'Data de término evento online*',
                    Hora: {
                      Label: 'Horário de término',
                      LabelOnline: 'Horário de término evento online',
                      Placeholder: 'Horário de término*',
                      PlaceholderOnline: 'Horário de término evento online*',
                    },
                  },
                },
              },
              Buttons: {
                Salvar: 'Salvar e prosseguir',
                Prosseguir: 'Avançar etapa',
                Editar: 'Editar evento',
              },
            },
            Entidade: {
              Nome: 'Entidades',
              Titulo: 'Seleção de Entidades',
              Subtitulo:
                'Escolha a Cooperativa, Agência(s) e Núcleo(s) para o evento.',
              Table: {
                UpperHeader: {
                  Editar: 'Editar',
                  Deletar: 'Deletar',
                },
                Head: {
                  Agencia: 'Agência',
                  Nucleo: 'Núcleo',
                },
              },
              Campos: {
                Cooperativa: {
                  Label: 'Cooperativa',
                  Placeholder: 'Nenhuma selecionada*',
                },
                Agencia: {
                  Label: 'Agência',
                  Placeholder: 'Nenhuma selecionada*',
                },
                Nucleo: {
                  Label: 'Núcleo',
                  Placeholder: 'Nenhum selecionado*',
                },
              },
              Buttons: {
                Adicionar: 'Adicionar',
                Salvar: 'Salvar e prosseguir',
                Voltar: 'Voltar etapa',
                Cancelar: 'Cancelar',
                Confirmar: 'Confirmar',
                Prosseguir: 'Avançar etapa',
                Editar: 'Editar evento',
              },
              Modal: {
                Deletar: {
                  Title: 'Deletar',
                  Mensagem: {
                    one: 'Esta agência e seus núcleos serão removidos dessa assembleia. Confirma a exclusão?',
                    many: 'Estas agências e seus núcleos serão removidos dessa assembleia. Confirma a exclusão?',
                  },
                },
                Editar: {
                  Title: 'Editar',
                },
              },
            },
            Local: {
              Nome: 'Local',
              Titulo: 'Cadastro de Local do Evento',
              Campos: {
                CEP: {
                  Label: 'CEP',
                  Placeholder: 'Digite o CEP',
                },
                Estado: {
                  Label: 'Estado',
                  Placeholder: 'Selecione o estado*',
                },
                Cidade: {
                  Label: 'Cidade',
                  Placeholder: 'Selecione a cidade*',
                },
                Bairro: {
                  Label: 'Bairro',
                  Placeholder: 'Digite o bairro*',
                },
                Endereco: {
                  Label: 'Endereço',
                  Placeholder: 'Digite o endereço*',
                },
                Numero: {
                  Label: 'Número',
                  Placeholder: 'Digite o número',
                },
                PontoReferencia: {
                  Label: 'Ponto de referência',
                  Placeholder: 'Digite o ponto de referência',
                },
              },
              Buttons: {
                Salvar: 'Salvar e prosseguir',
                Voltar: 'Voltar etapa',
                Prosseguir: 'Avançar etapa',
                Editar: 'Editar evento',
              },
            },
            Pauta: {
              Nome: 'Pautas',
              Titulo: 'Cadastro de Pautas',
              Table: {
                UpperHeader: {
                  Editar: 'Editar',
                  Deletar: 'Deletar',
                },
                Head: {
                  Titulo: 'Título',
                  Tipo: 'Tipo de pauta',
                  Confidencialidade: 'Confidencialidade da pauta',
                  Opcoes: 'Opções de voto',
                  Agencia: 'Agência',
                  Nucleo: 'Núcleo',
                },
              },
              Buttons: {
                AdicionarPauta: 'Adicionar pauta',
                CopiarPauta: 'Copiar pauta',
                Salvar: 'Salvar e prosseguir',
                Voltar: 'Voltar etapa',
                Prosseguir: 'Avançar etapa',
                Editar: 'Editar evento',
              },
              Modal: {
                Deletar: {
                  Title: 'Deletar',
                  Mensagem: {
                    one: 'A(s) pauta(s) selecionada(s) serão removidas da lista. Confirma exclusão?',
                  },
                },
                Editar: {
                  Title: 'Editar',
                },
              },
            },
            Pesquisa: {
              Titulo: 'Pesquisa de satisfação',
              PrimeiroSubtitulo:
                'Você pode incluir uma pesquisa de satisfação para esse evento:',
              SegundoSubtitulo:
                'Pesquisas são importantes para você entender o que os participantes acharam de seu evento.',
              Modal: {
                Titulo: 'Confirmação',
                Subtitulo:
                  'Há modificações que ainda não foram salvas. Você deseja salvar essas alterações antes de alterar a etapa atual?',
                Buttons: {
                  Salvar: 'Salvar',
                  Cancelar: 'Não salvar',
                },
              },
              Campos: {
                TeraPesquisa: 'Evento terá pesquisa de reação?',
              },
              Buttons: {
                Visualizar: 'Baixar pesquisa',
                Salvar: 'Salvar e prosseguir',
                Voltar: 'Voltar etapa',
                Prosseguir: 'Avançar etapa',
                Editar: 'Editar evento',
              },
              Errors: {
                Default: 'Houve um problema em editar o evento',
                Step: 'Erro ao salvar a etapa',
              },
            },
            Anexo: {
              Nome: 'Anexos',
              Titulo: 'Inserção de anexos',
              Subtitulo: () => {
                return (
                  <Fragment>
                    Insira os anexos do evento.
                    <br />O campo descrição será exibido na apresentação da
                    plataforma do associado.
                  </Fragment>
                );
              },
              Table: {
                UpperHeader: {
                  Editar: 'Editar',
                  Deletar: 'Deletar',
                },
                Head: {
                  Tipo: 'Tipo',
                  Titulo: 'Título',
                  Descricao: 'Descrição',
                  Visibilidade: 'Visível para associado',
                  Date: 'Data de upload',
                },
              },
              Modal: {
                PDF: {
                  UploadLabel: () => (
                    <Fragment>
                      Upload de anexos (um arquivo por vez)
                      <br />
                      Arraste e solte o arquivo nesta área ou
                      <b style={{ color: '#3fa110' }}>
                        {' '}
                        procure no dispositivo.
                      </b>
                    </Fragment>
                  ),
                },
                Videos: {
                  Title: {
                    Editar: 'Editar vídeo',
                    Adicionar: 'Adicionar vídeo',
                  },
                  EventVideo: 'Vídeos para o evento: ',
                  Campos: {
                    URL: {
                      Label: 'URL',
                      Placeholder: 'URL do vídeo*',
                    },
                    Descricao: {
                      Label: 'Descrição',
                      Placeholder: 'Descrição do vídeo*',
                    },
                    Visibilidade: 'Visível para associado',
                  },
                  Buttons: {
                    Cancel: 'Cancelar',
                    AddVideo: 'Adicionar vídeos',
                    Save: 'Salvar',
                  },
                },
                Deletar: {
                  Title: 'Deletar',
                  Mensagem: {
                    one: 'O anexo selecionado será removido da lista. Confirma a exclusão?',
                    many: 'Os anexos selecionados serão removidos da lista. Confirma a exclusão?',
                  },
                },
              },
              Buttons: {
                AdicionarPDF: 'Adicionar anexos',
                AdicionarVideo: 'Adicionar vídeos',
                Voltar: 'Voltar etapa',
                Salvar: 'Salvar',
                Disponibilizar: 'Salvar e disponibilizar',
                Editar: 'Editar evento',
              },
            },
          },
        },
        Vote: {
          title: 'Votos',
          address: (address: string) =>
            `Endereço: ${address ?? 'Não especificado'}`,
          cards: {
            associadosConvocados: 'Associados convocados',
            associadosPresentes: 'Associados Presentes',
            associadosAptos: 'Associados Aptos',
            convidadosPresentes: 'Convidados Presentes',
            totalDeParticipantes: 'Total de participantes',
          },
          staves: 'Pautas',
          withoutAgendas: 'Não há pautas para serem exibidas',
          agendas: {
            associate: (
              present: string | number,
              ablePresent: string | number
            ) =>
              `Associados presentes: ${present} | Associados aptos: ${ablePresent}`,
            infos: (branch: string | number, nucleou: string | number) =>
              `Agência: ${branch} Núcleo: ${nucleou}`,
            button: 'Visualizar votos por núcleo',
          },
        },
        Relatory: {
          title: 'Relatórios',
        },
      },
    },
    Associado: {
      Pages: {
        home: {
          Cards: {
            VerMais: 'Ver Mais...',
            VerMenos: 'Ver Menos',
            Observacao: 'Observação: ',
            ConfirmePresencaGerente: 'Confirme a presença com seu gerente.',
            ConfiraData: 'Confira a data e horário para participar.',
            Digital: 'Digital:',
            Presencial: 'Presencial:',
            ConfiraLocal: 'Confira o local, data e horário clicando em ',
            'ConfiraData:': 'Confira a data e horário para participar: ',
            EventoFinalizado: 'Evento finalizado',
            ConfirmePresencaAgencia: 'Confirme presença na sua agência.',
            CliqueAqui: 'Clique aqui para acessar.',
            VaParaAgencia:
              'Para participar, vá até sua agência de atendimento.',
          },
        },
      },
      Modal: {
        SatisfactionSurvey: {
          title: 'Pesquisa de satisfação',
          thanks: 'Obrigado pela sua participação!',
          betterAssembly:
            'Sua participação ajudará a melhorar os eventos de assembleia.',
        },
      },
    },
    Toasts: {
      Errors: {
        defaultAlternative:
          'Um problema inesperado ocorreu. Aguarde alguns minutos e tente novamente.',
        typeNotAllowed: 'Formato do arquivo não suportado!',
        uploadSize: 'Limite de arquivo é de 35 MB!',
        loadingAnexos: 'Erro ao carregar anexos!',
        downloadAnexo: 'Erro ao baixar o anexo!',
        reorderPauta: 'Houve um problema em reordenar as pautas',
        presencaNotFound: 'Não foram encontrados dados para este CPF.',
        loadInfoCreateEvent:
          'Não foi possível carregar as informações para a criação do evento',
        loadInfoEvent: 'Não foi possível carregar as informações do evento',
        errLoadCEP: 'Não foi possível encontrar o CEP informado.',
        errLoadCEP2: 'Houve um problema em buscar o CEP informado.',
        loadCooperative: 'Não foi possível carregar as cooperativas',
        loadTemplates: 'Não foi possível carregar os templates de pesquisa',
        loadAgency: 'Não foi possível carregar as agencias',
        loadNucleou: 'Não foi possível carregar os núcleos',
        relatoryDownload:
          'Houve um problema em baixar o relatório de convocados, tente novamente mais tarde',
        Keys: {
          'convidado.notFound': 'Convidado não encontrado',
          'evento.dataFim.expirada':
            'O período para confirmação de presença para este evento encerrou em #dataFim#1# às #dataFim#2#.',
          'evento.fora-do-horario':
            'O evento está fora do horário permitido para alterações.',
          'startDate.retroactiveDateOutOfPeriod':
            'A data de início está fora do período permitido.',
          'arquivo.notNull': 'Arquivo não pode ser nulo.',
          'role.notAllowed':
            'Você não tem permissão para realizar esta ação com o perfil atual.',
          'reportType.unavailable': 'Este relatório não existe.',
          'report.hasError':
            'Um problema inesperado ocorreu. Por favor, tente gerar o relatório novamente. Se o problema persistir, entre em contato com a equipe de suporte.',
          'report.notAllowed': 'Não é possível gerar este relatório.',
          'event.notFinished': 'Este evento ainda está em andamento.',
          'event.notOffline': 'Este evento não é presencial.',
          'vote.agenda.notFound': 'Pauta não encontrada',
          'vote.branch.nucleus.notFound':
            'Agência e núcleo não encontrado conforme a pauta',
          'vote.flagNoVotes.denied': 'Não é permitido pauta sem voto',
          'vote.withAcclamation.denied':
            'Não é permitido votação por aclamação',
          'vote.missing':
            'Falta votos, deve ser igual ao associados aptos por núcleo',
          'vote.item.notFound': 'Opção de voto não encontrado',
          'hybridStartDate.retroactiveDateNotAllowed':
            'Horário do momento digital, não pode ser anterior a data atual',
          'startDate.retroactiveDateNotAllowed':
            'Data de início não deve ser anterior a data atual',
          mapearAChaveAqui:
            'Momento presencial ainda não finalizado. Finalize para então iniciar o momento digital',
          'associateQuantity.invalid':
            'O evento é inválido para conter a quantidade de associado',
          'associateQuantity.invalidQuantityAssociates':
            'É necessário ser informado a quantidade de associados',
          'associateQuantity.quantityAssociatesOverflow':
            'Essa data e horário já atingiu a capacidade máxima da Plataforma. Verifique a disponibilidade de outra data e hora',
          'codigoAgencia.notNull': 'Código da agência não pode ser nulo.',
          'codigoCooperatia.notFound':
            'Código da cooperativa não encontrado na configuração de núcleos',
          'codigoNucleo.notNull': 'Código do núcleo não pode ser nulo.',
          'convocado.notFound': 'Convocado não encontrado.',
          'coop.notFound': 'Cooperativa não encontrado.',
          'coopEOWS.notFound':
            'Cooperativa não encontrada na estrutura organizacional.',
          'cooperativa.error': 'Esta cooperativa já existe na lista.',
          'cooperativa.notFound': 'Cooperativa não encontrada.',
          'report.notAvailable':
            'Geração do relatório está em andamento, tente novamente mais tarde.',
          'cooperative.denied': 'Não possui acesso a está cooperativa.',
          'cpf.presentInOtherChannel.ONLINE':
            'Cpf possui contas com presença confirmada pelo canal digital.',
          'dataBloqueio.error':
            'Não é possível efetuar o bloqueio do evento. Atualize a tela da Assembleia.',
          'dataFimCadastro.notNull': 'Data final do filtro não pode ser nula.',
          'dataInicioCadastro.notNull':
            'Data inicial do filtro não pode ser nula.',
          'date.notNull': 'Data não pode ser nula.',
          'dateFinish.notNull': 'Data final não pode ser nula.',
          'dateStart.notNull': 'Data inicial não pode ser nula.',
          'datEventoOnline.error':
            'Em eventos do modo Híbrido, as datas não podem ser nulas.',
          'deletePauta.error':
            'Não é possível excluir a Pauta pois já foi liberada para votação pelo menos uma vez.',
          'descriaoItemPauta.notNull':
            'Descrição do Item da Pauta não pode ser nula.',
          'descricao.notNull': 'Descrição não pode ser nula.',
          'description.invalidSize':
            'Tamanho da descrição superior a 300 caracteres',
          'documento.notFound': 'Documento não encontrado.',
          'duvida.notFound': 'Duvida não encontrada.',
          'duvida.notNull': 'Dúvida não pode ser nula.',
          'endDate.before.startDate':
            'Data fim não pode ser anterior a data de inicio',
          'endDate.notNull': 'Data fim não pode ser nulo',
          'err.userDuvida': 'Problemas ao montar dados de duvidas.',
          errMakeEditable: 'Houve um problema em editar o evento',
          'error.400': 'Problema com dados da requisição.',
          'error.401': 'Operação não autorizada.',
          'error.403': 'Operação proibida.',
          'error.417': 'Problema de validação.',
          'error.500': 'Problema inesperado.',
          'error.argumentNotValid': 'Problema com dados da requisição.',
          'error.jsonProcessing': 'JSON de entrada inválido.',
          'error.methodArgumentTypeMismatch': 'Parâmetro inválido.',
          'error.missingServletRequestParameter': 'Falta um parâmetro.',
          'error.pesquisarParticipantesProcesso':
            'erro ao buscar cooperativas do usuário.',
          'event.convocationIsRunning':
            'O processo de convocação dos associados desta assembleia está em andamento. Por isso, não é possível edita-la neste momento.',
          'event.convocationIsRunningMessage':
            'O processo de convocação dos associados desta assembleia está em andamento. Por isso, não é possível acessá-la neste momento.',
          'event.isAlreadyBlocked':
            'Não é possível editar o evento. O evento já está bloqueado',
          'event.isDeleted': 'O evento informado não existe.',
          'event.isntPreEvent':
            'Evento não disponível, para prosseguir altere o status do evento para preparação.',
          'event.legalRepresentativeDeletionInProgress':
            'O processo de reconvocação dos associados desta assembleia está em andamento. Por isso, não é possível disponibiliza-la neste momento.',
          'event.mustHaveElectionCommission':
            'Para salvar e disponibilizar o evento com pauta(s) de Conselho é necessário que exista uma Comissão Eleitoral.',
          'event.mustBeEditable': 'O evento não está em edição',
          'event.notAvailable': 'O evento não está disponível',
          'evento.notConvocados':
            'Evento não disponível, verifique a situação do evento no Pertencer.',
          'evento.notFound.code': 'EVNOTFOU01',
          'evento.notFound': 'Evento não encontrado.',
          'evento.notHibrido': 'Evento não é Híbrido.',
          'eventoAgn.error': 'Evento não é dos tipos AGN ou REU.',
          'eventoAgos.error': 'Evento não é dos tipos AGO, AGE ou AOE.',
          'eventoHibridoAgencia.notActive':
            'O evento está indisponível. Não é possível confirmar presença e/ou votar, confira o horário do evento para à agência.',
          'eventoHibridoSimultaneo.notActive':
            'O evento está indisponível. Não é possível confirmar presença, confira o horário do evento.',
          'eventoModoApresentacao.invalid':
            'Relatório só pode ser emitido para eventos Online ou Híbridos.',
          'eventoStatus.invalid':
            'Para emitir o relatório o evento precisa estar no status Encerrado.',
          'expiry.period': 'Período da duração foi expirado.',
          'feature.doesnt.work.with.offline':
            'Esta funcionalidade não funciona com os eventos presencial.',
          'flagDeclaracaoSemVotos.cannot.checked':
            'A declaração não pode ser marcado quando existem votos preenchidos.',
          'flagDeclaracaoSemVotos.must.checked':
            'A declaração deve ser marcado quando não existem votos preenchidos.',
          'flagDeclaracaoSemVotos.notNull': 'A declaração não pode ser nulo.',
          'flgDisponivelAssociado.notNull': 'Flag não pode ser nula.',
          'flgPublica.notNull': 'flgPublica não pode ser nulo.',
          'hybridEndDate.before.hybridStartDate':
            'Data final hibrido não pode ser anterior a data inicio hibrido',
          'hybridEndDate.invalid':
            'Não pode ser preenchido a data final hibrido por causa da modalidade selecionada',
          'hybridEndDate.notNull':
            'Data fim hibrido não pode ser nulo por causa da modalidade selecionada',
          'hybridStartDate.hibridoPresencialDigital.invalid':
            'Data inicio hibrido não pode ser anterior a data fim do evento caso a modalidade for HIBRIDO_DIGITAL_AGENCIA',
          'hybridStartDate.invalid':
            'Não pode ser preenchido a data inicio hibrido por causa da modalidade selecionada',
          'hybridStartDate.notNull':
            'Data inicio hibrido não pode ser nulo por causa da modalidade selecionada',
          'hybridStartDate.outOfPeriod':
            'Data inicio hibrido deve ser igual ou superior ao ano 2018',
          'idConvocado.notNull': 'Id do convocado não pode ser nulo.',
          'idDuvida.notNull': 'idDuvida da Dúvida não pode ser nulo.',
          'idEvento.notNull': 'Id do evento não pode ser nulo.',
          'idItemPauta.notNull': 'idItemPauta não pode ser nulo.',
          'idPauta.notNull': 'idPauta não pode ser nulo.',
          'idVideo.notNull': 'idVideo não pode ser nulo.',
          'itemAbstencao.notFound':
            'Não é possível inserir apenas o item de Abstenção, uma outra opção de voto deve existir.',
          'itemPauta.error': 'É obrigatório existir um item de tipo Abstenção.',
          'itemPauta.notFound': 'Item de Pauta não encontrado.',
          'itensPauta.notNull': 'Lista de itens de pauta não pode ser nula.',
          'ldap.notNull': 'Ldap não pode ser nulo',
          'link.invalid':
            'Não pode preencher o link conforme a modalidade selecionada',
          'link.notNull':
            'Link não pode ser nulo por causa da modalidade selecionada',
          'modality.invalid': 'Modalidade informada é invalido',
          'modality.notNull': 'Modalidade do evento não pode ser nulo',
          'modoEvento.notFound': 'Modo de Evento não encontrado.',
          'nomeDocumento.notNull': 'Nome do documento não pode ser nulo.',
          'oidDocumento.notNull': 'oidDocumento não pode ser nulo.',
          'parametro.notNull': 'Parâmetro não pode ser nulo.',
          'parametroCoopDelete.error':
            'Não é possível excluir os parâmetros da cooperativa, existem eventos na situação assembleia.',
          'parametroCoopStatusEventoLive.error':
            'Não é possível alterar os parâmetros da cooperativa, existem eventos na situação assembleia.',
          'parametroCoopStatusEventoLiveOrPre.error':
            'Não é possível alterar os parâmetros da cooperativa, existem eventos na situação Assembleia ou Pré assembleia.',
          'parametroOcultarNomeChat.notNull':
            'Parâmetro ocultar nome do chat não pode ser nulo.',
          'pauta.error':
            'Não é possível modificar Pautas devido a situação do evento.',
          'pauta.missingVotes.code': 'MSSNGVTS01',
          'pauta.missingVotes':
            'Pauta ainda não possui voto computado para todas Agências/Núcleos.',
          'pauta.notAwareToDelete':
            'Não foi possível excluir, pois a pauta já foi liberada no presencial',
          'pauta.notAwareToEdit':
            'Não foi possível editar, pois a pauta já foi liberada no presencial',
          'pauta.notClosed': 'Pauta não está encerrada.',
          'pauta.notFound': 'Pauta não encontrada.',
          'pauta.presentialResultNotReleased':
            'Não é possível encerrar evento, resultado presencial ainda não foi liberado',
          'pauta.resultadoJaLiberado': 'Resultado da pauta está liberado.',
          'pautaEventoHibrido.error':
            'Não é possível modificar Pautas, evento de modo Híbrido já esta bloqueado.',
          'pautaRestritaUpdate.error':
            'Não é possível alterar a opção Restrita após liberar a pauta ou bloquear o evento.',
          'pautas.notEmpty': 'Deve informar pelo menos uma pauta na lista.',
          'pautas.notFound': 'Pautas não encontradas.',
          'pautas.notNull': 'Lista de pautas não pode ser nulo.',
          'perfil.notFound': 'Perfil usuário Enum não encontrado.',
          'permissaoCooperativa.error':
            'Usuário não tem permissão para adicionar essa cooperativa.',
          'presenca.notFound':
            'Não há presença confirmada apta a votar nesta pauta.',
          'presence.management.invalid':
            'Não tem nenhum usuário realizando a votação',
          'presence.notFound':
            'Não existe nenhuma presenca através da agência, núcleo e pauta informada',
          'quantidade.notMatch':
            'Quantidade de votos informada é maior que a quantidade de presenças confirmadas.',
          'quantidadeVotoPesencial.error': 'Votos incoerentes.',
          'quantidadeVotos.notNull': 'quantidadeVotos não pode ser nulo.',
          'quorum.alreadyDefined': 'Quórum já foi definido.',
          'quorum.alreadyUpdated': 'Representante do núcleo já foi modificado.',
          'quorum.notFound': 'Não há presença marcada para este evento.',
          'report.eventNotAvailable': 'O evento não está disponível.',
          'report.generationInProgress':
            'A geração do relatório está em andamento. Por favor, aguarde alguns instantes e tente novamente.',
          'eventSurveyReport.notAvailable':
            'Relatório será disponibilizado no dia posterior a finalização do evento, tente novamente mais tarde.',
          'eventSurveyReport.generationInProgress':
            'A geração do relatório está em andamento. Por favor, aguarde alguns instantes e tente novamente.',
          'eventSurveyReport.notAvailableYet':
            'Relatório será disponibilizado no dia posterior a finalização do evento, tente novamente mais tarde.',
          'report.notAvailableYet':
            'Relatório ainda não está disponível, aguarde uns minutos e tente novamente.',
          'representante.alreadyActive':
            'Representante do núcleo informado já pertence ao quórum informado.',
          'representante.notFound': 'Representante do núcleo não encontrado.',
          'resposta.notNull': 'Resposta não pode ser nula.',
          'respostaPadrao.denied': 'Não possui acesso a está resposta padrão.',
          'respostaPadrao.exceeded.limit':
            'Sua Cooperativa já atingiu o limite de respostas padrão.',
          'respostaPadrao.notFound': 'Resposta padrão não encontrado.',
          'restrito.notVote': 'Conta restrita não pode votar nessa pauta.',
          'startDate.notNull': 'Data de inicio não pode ser nulo',
          'startDate.outOfPeriod':
            'Data inicio deve ser igual ou superior ao ano 2018',
          'statusChat.notFound': 'Status do chat não encontrado.',
          'statusChat.notNull': 'Status do chat não pode ser nulo.',
          'statusEvento.error':
            'Não é permitido bloquear, status do evento está diferente de Disponível.',
          'statusEvento.notFound': 'Status de evento não encontrado.',
          'statusEvento.notNull': 'Status não pode ser nulo.',
          'statusEvento.notWorking':
            'Funcionalidade indisponível para o status atual do evento.',
          'statusEventoEncerrado.error':
            'Não é possível alterar a situação do evento, a situação atual não é Assembleia.',
          'statusEventoEncerrado.errorPauta':
            'Não é possível alterar a situação do evento, existem pautas não encerradas.',
          'statusEventoEncerrado.errorPautaVotacao':
            'Não é possível alterar a situação do evento, existem pautas em processamento de votos.',
          'statusEventoEncerrado.missingVotes':
            'Evento possui pauta que ainda não possui voto computado para todas Agências/Núcleos.',
          'statusEventoEncerradoQuorum.errorChat':
            'Não é possível habilitar o chat para eventos encerrados sem quórum.',
          'statusEventoEncerradoQuorum.errorHasQuorum':
            'Não é possível alterar a situação do evento, evento possui quórum para votação.',
          'statusEventoEncerradoQuorum.errorTipo':
            'Não é possível alterar a situação do evento, o tipo do evento deve ser AGN.',
          'statusEventoEncerradoQuorum.errorTipoEvento':
            'Não é possível alterar a situação do evento, o tipo do evento deve ser Híbrido agência ou Online.',
          'statusEventoLive.error':
            'Não é possível alterar a situação do evento, a situação atual não é Não Disponível ou Pré Assembleia.',
          'statusEventoLive.errorBloqueio':
            'Não é possível alterar a situação do evento. Realize primeiramente o bloqueio do evento.',
          'statusEventoLive.errorModoHibrido':
            'Não é possível alterar a situação do evento, finalize o evento nos dispositivos offline.',
          'statusEventoLive.errorModoHibridoInconsistente.code': 'MDHBRDNCST01',
          'statusEventoLive.errorModoHibridoInconsistente':
            'Não é possível alterar a situação do evento, há inconsitência em votos no evento presencial',
          'statusEventoLive.errorUrlTransmissao':
            'Necessário cadastrar URL de transmissão.',
          'statusEventoNaoDisponivel.error':
            'Não é possível alterar a situação do evento, a situação atual não é Pré Assembleia.',
          'statusEventoPos.error':
            'Não é possível alterar a situação do evento, situação não é válida.',
          'statusEventoPre.error':
            'Não é possível alterar a situação do evento, a situação atual não é Não Disponível ou Assembleia.',
          'statusEventoPre.hibrida_tablet':
            'Não é possível alterar a situação do evento, modo do evento é Híbrido-Tablet.',
          'statusEventoPre.pautaError':
            'Não é possível alterar a situação do evento, existem pautas não bloqueadas.',
          'statusPauta.notNull': 'Status não pode ser nulo.',
          'tamanhoDoc.notNull': 'Tamanho do documento não pode ser nulo.',
          'texto.notNull': 'Campo texto não pode ser nulo.',
          'tipoDocumento.notNull': 'Tipo de documento não pode ser nulo.',
          'tipoPauta.notFound': 'Tipo de pauta não encontrado.',
          'tipoPauta.notNull': 'Tipo da Pauta não pode ser nulo.',
          'tipoResultado.notNull':
            'Parâmetro Tipo de Resultado não pode ser nulo.',
          'title.invalidSize': 'Tamanho do título superior a 100 caracteres',
          'title.notNull': 'Título não pode ser nulo',
          'titulo.notNull': 'Título não pode ser nulo.',
          'tituloPauta.notNull': 'Título da Pauta não pode ser nulo.',
          'type.invalid': 'Tipo evento informado é invalido',
          'type.modality.invalid':
            'Tipo evento não corresponde a modalidade selecionada',
          'type.notNull': 'Tipo do evento não pode ser nulo',
          'url.notNull': 'URL não pode ser nula.',
          'urlVideo.notNull': 'Campo url não pode ser nulo.',
          'user.access.denied':
            'Usuário sem permissão para realizar esta ação!',
          'video.notFound': 'Video não encontrado.',
          'vote.flagNoVotes.invalid':
            'Foi marcado a flag sem votos, porém existem votos ou foi realizado a aclamação',
          'vote.quantityVotes.exceeded':
            'A quantidade de votos é maior que a quantidade de presentes aptos',
          'evento.finalizacaoEmAndamento':
            'O evento está sendo finalizado. Por favor, aguarde.',
          'request.timeout.download.documentCoop':
            'Erro ao solicitar o documento #tipoDocumento. Por favor, contate a sua cooperativa.',
        },
      },
      Success: {
        reorderPauta: 'As pautas foram reordenadas',
        Keys: {},
      },
    },
  },
};

const rawLang: string = (
  navigator.language ||
  document.documentElement.lang ||
  'pt-br'
).toLowerCase();

const languageMap: { [key: string]: string } = {
  pt: 'pt-br',
};

const lang = languageMap[rawLang.split('-')[0]] || rawLang;

export default languageValues[lang as keyof typeof languageValues] ??
  languageValues['pt-br'];
